import _ from 'lodash'

export default {
  data() {
    return {
      commentsVisibilityStates: ['default', 'all', 'none'],
      commentsVisibilityStateId: 0,
    }
  },

  methods: {
    setCommentsVisibilityState(state) {
      this.commentsVisibilityStateId =
        this.commentsVisibilityStates.indexOf(state)
    },

    toggleShowAllComments() {
      switch (this.commentsVisibilityState) {
        case 'default':
          this.setCommentsVisibilityState('all')
          break
        case 'all':
          this.setCommentsVisibilityState('none')
          break
        case 'none':
          this.setCommentsVisibilityState('all')
          break
      }
    },
  },

  computed: {
    commentsVisibilityState() {
      return this.commentsVisibilityStates[this.commentsVisibilityStateId]
    },

    allComments() {
      return _.orderBy(
        this.commentsByIds(this.commentIds),
        ['createdAt'],
        ['asc']
      )
    },

    allCommentsCount() {
      return this.allComments.length
    },

    showCommentsToggle() {
      return this.allCommentsCount > this.SHOW_COMMENTS_TOGGLE_TRESHOLD
    },
  },
}
